import type * as React from "react";
import { Avatar as BaseAvatar } from "@base-ui/react/avatar";
import { cn } from "../lib/cn";

export function Avatar({ className, ...props }: React.ComponentProps<typeof BaseAvatar.Root>) {
  return (
    <BaseAvatar.Root
      className={cn(
        "relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full bg-primary-100 ring-1 ring-inset ring-primary-200/60",
        className,
      )}
      {...props}
    />
  );
}

export function AvatarImage(props: React.ComponentProps<typeof BaseAvatar.Image>) {
  return <BaseAvatar.Image className="aspect-square h-full w-full object-cover" {...props} />;
}

export function AvatarFallback({ className, ...props }: React.ComponentProps<typeof BaseAvatar.Fallback>) {
  return (
    <BaseAvatar.Fallback
      className={cn("flex h-full w-full items-center justify-center text-sm font-medium text-primary-700", className)}
      {...props}
    />
  );
}
